import React from "react";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";

// API call
import { userLoginRequest } from "../../../api/api";

// Custom UI Components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";

import Card from "@mui/material/Card";

// Background Image
import bgImage from "assets/images/bg-sign-in-basic.jpeg";

function SignIn() {
  const navigate = useNavigate();

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox pt={4} pb={3} px={3}>
          <Formik
            initialValues={{
              email: "",
              password: "",
            }}
            validationSchema={Yup.object().shape({
              email: Yup.string().email("Must be a valid email").required("Email is required"),
              password: Yup.string().required("Password is required"),
            })}
            onSubmit={async (values, { setErrors, setSubmitting }) => {
              try {
                setSubmitting(true);

                const response = await userLoginRequest({
                  email: values.email,
                  password: values.password,
                });

                // Try all possible token response formats
                const token =
                  response?.data?.data?.token ||
                  response?.data?.data?.access_token ||
                  response?.data?.token;

                if (token) {
                  // localStorage.setItem("authToken", token);
                  const expiryTime = new Date().getTime() + 24 * 60 * 60 * 1000; // 24 hours
                  localStorage.setItem("authToken", token);
                  localStorage.setItem("authTokenExpiry", expiryTime.toString());

                  localStorage.setItem("user", JSON.stringify(response.data.data));
                  navigate("/dashboard");
                } else {
                  throw new Error("Invalid login response: token not found");
                }
              } catch (error) {
                setErrors({
                  submit: error?.response?.data?.message || error?.message || "Login failed",
                });
              } finally {
                setSubmitting(false);
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <form noValidate onSubmit={handleSubmit}>
                <MDBox mb={2}>
                  <MDInput
                    fullWidth
                    label="Email"
                    name="email"
                    type="email"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.email && errors.email)}
                    helperText={touched.email && errors.email}
                  />
                </MDBox>
                <MDBox mb={2}>
                  <MDInput
                    fullWidth
                    label="Password"
                    name="password"
                    type="password"
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.password && errors.password)}
                    helperText={touched.password && errors.password}
                  />
                </MDBox>
                {errors.submit && (
                  <MDTypography color="error" variant="caption">
                    {errors.submit}
                  </MDTypography>
                )}
                <MDBox mt={4} mb={1}>
                  <MDButton
                    type="submit"
                    variant="gradient"
                    color="info"
                    fullWidth
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Signing in..." : "Sign in"}
                  </MDButton>
                </MDBox>
              </form>
            )}
          </Formik>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default SignIn;
